const resolveAdminAssignedMembershipPlanType = (userData) => {
  const profilePlanType = userData?.profile?.plan_type;
  const profilePaymentStatus = userData?.profile?.payment_status;

  return profilePlanType && profilePaymentStatus === "complimentary"
    ? profilePlanType
    : null;
};

export const resolveCurrentMembershipPlanType = (userData) => {
  const membershipPlanType = userData?.membership?.membership?.plan_type;
  const isCurrent = userData?.membership?.membership?._is_expired === false;
  const adminPlanType = resolveAdminAssignedMembershipPlanType(userData);

  if (membershipPlanType && isCurrent) {
    return membershipPlanType;
  }

  return adminPlanType;
};

export const resolveEffectiveMembershipPlanType = resolveCurrentMembershipPlanType;

export const isMeetingPlanVisibleForUser = (planType, userData) => {
  if (!userData) {
    return planType !== "meeting_member";
  }

  const effectivePlanType = resolveCurrentMembershipPlanType(userData);

  if (effectivePlanType === "membership_trainee") {
    return planType === "meeting_discounted50";
  }

  if (
    [
      "membership_active",
      "membership_affiliate",
      "membership_international",
      "membership_complimentary",
    ].includes(effectivePlanType)
  ) {
    return planType === "meeting_member";
  }

  // Authenticated users without current or admin-assigned coverage may only
  // use the standard non-member registration option. Unauthenticated visitors
  // retain the existing self-selected discounted option.
  if (userData) {
    return planType === "meeting_nonmember";
  }

  return planType !== "meeting_member";
};
